import * as Constants from '../Constants.js';
import * as DataUtils from '../data/DataUtils.js';

export const Authenticated = async () => {
  try {
    const response = await fetch(Constants.URLBASE + '/authenticated', {
      method: 'GET',
      credentials: 'include',
    });

    return response.ok;
  } catch (error) {
    console.log('Authenticated', error);
    throw new Error(error.message);
  }
};

export const GetUsuario = async () => {
  return DataUtils.FetchObject('usuario');
};

export const Heartbeat = async () => {
  try {
    // IMPORTANT: do not send credentials/cookies here so the server
    // does not refresh the user's session when answering the heartbeat.
    // This makes Heartbeat a pure liveness check.
    const response = await fetch(Constants.URLBASE + '/heartbeat', {
      method: 'GET',
      // Do NOT include credentials: sending cookies would let the server
      // touch/refresh the session expiration. We want a non-intrusive check.
      credentials: 'omit',
      cache: 'no-store',
    });

    return response.ok;
  } catch {
    return false;
  }
};
